var CustomQuantitySelector = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.inputElement = this.querySelector("input");
    this.querySelector("button:first-of-type").addEventListener(
      "click",
      () => (this.inputElement.quantity = this.inputElement.quantity - 1),
      { signal: this._abortController.signal }
    );
    this.querySelector("button:last-of-type").addEventListener(
      "click",
      () => (this.inputElement.quantity = this.inputElement.quantity + 1),
      { signal: this._abortController.signal }
    );
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};

var CustomQuantityInput = class extends HTMLInputElement {
  constructor() {
    super();
    this.addEventListener("input", this._onValueInput);
    this.addEventListener("change", this._onValueChanged);
    this.addEventListener("keydown", this._onKeyDown);
    this.addEventListener("focus", this.select);
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  get quantity() {
    return parseInt(this.value);
  }
  set quantity(quantity) {
    const isNumeric =
      (typeof quantity === "number" ||
        (typeof quantity === "string" && quantity.trim() !== "")) &&
      !isNaN(quantity);
    if (quantity === "") {
      return;
    }
    if (!isNumeric || quantity < 0) {
      quantity = parseInt(quantity) || 1;
    }
    this.value = Math.max(
      this.min || 1,
      Math.min(quantity, this.max || Number.MAX_VALUE)
    ).toString();
    this.size = Math.max(this.value.length + 1, 2);
    this._calculateSurface();
    window.dispatchEvent(
      new CustomEvent("quantity:change", {
        bubbles: true,
        detail: {
          quantity: this.value,
        },
      })
    );
  }
  _onValueInput() {
    this.quantity = this.value;
  }
  _onValueChanged() {
    if (this.value === "") {
      this.quantity = 1;
    }
  }
  _onKeyDown(event) {
    event.stopPropagation();
    const originalQuantity = this.quantity;
    if (event.key === "ArrowUp") {
      this.quantity = this.quantity + 1;
    } else if (event.key === "ArrowDown") {
      this.quantity = this.quantity - 1;
    }
    if (originalQuantity !== this.quantity) {
      this._abortController = new AbortController();
      this.addEventListener(
        "blur",
        () => this.dispatchEvent(new Event("change", { bubbles: true })),
        { once: true, signal: this._abortController.signal }
      );
    }
  }
  _calculateSurface() {
    const areaField = document.querySelector("input[name='area']");
    if (!areaField) {
      return;
    }
    const unit = this.getAttribute("data-calculator-unit");
    const area = parseFloat(this.getAttribute("data-calculator-area"));
    if (isNaN(area)) {
      return;
    }
    var decimalPlaces = 2;
    // if (area.toString().split(".").length == 2) {
    //   decimalPlaces = area.toString().split(".")[1].length;
    // }
    var round = decimalPlaces == 1 ? 10 : decimalPlaces == 2 ? 100 : 1;
    const surface = (Math.round(area * this.quantity * round) / round).toFixed(
      decimalPlaces
    );
    areaField.value = surface + " " + unit;
  }
};

var CustomQuantityAreaInput = class extends HTMLInputElement {
  constructor() {
    super();
    this.addEventListener("input", this._onValueInput);
    this.addEventListener("change", this._onValueChanged);
    // this.addEventListener("keydown", this._onKeyDown);
    this.addEventListener("focus", this._onSelect);
    this.addEventListener("blur", this._onBlur);
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  get area() {
    return parseFloat(this.value);
  }
  set area(area) {
    var formattedArea = area
      .toString()
      .replace(",", ".")
      .replace(/[^\d.]/g, "");
    this.value = formattedArea;
    this._calculateAmount();
  }
  _onValueInput() {
    this.area = this.value;
  }
  _onValueChanged() {
    if (this.value === "") {
      this.area = 1;
    }
  }
  _onSelect(event) {
    this.select();
    const unit = this.getAttribute("data-calculator-unit");
    this.area = this.value.replace(unit, "").trim();
  }
  _onBlur(event) {
    const unit = this.getAttribute("data-calculator-unit");
    var area = parseFloat(this.getAttribute("data-calculator-area"));
    var decimalPlaces = 2;
    // if (area.toString().split(".").length == 2) {
    //   decimalPlaces = area.toString().split(".")[1].length;
    // }
    var round = decimalPlaces == 1 ? 10 : decimalPlaces == 2 ? 100 : 1;

    var value = (Math.round(this.value * round) / round).toFixed(decimalPlaces);
    this.value = value + " " + unit;
  }
  _calculateAmount() {
    var area = parseFloat(this.getAttribute("data-calculator-area"));
    var total = parseFloat(this.area);
    var lost = 0;
    if (lost > 0) {
      total *= 1 + lost / 100;
    }
    var quantity = document.querySelector("input[name='quantity']");
    quantity.value = Math.ceil(total / area);
    if (isNaN(quantity.value)) {
      quantity.value = 1;
    }
    window.dispatchEvent(
      new CustomEvent("quantity:change", {
        bubbles: true,
        detail: {
          quantity: quantity.value,
        },
      })
    );
  }
};

if (!window.customElements.get("custom-quantity-selector")) {
  window.customElements.define(
    "custom-quantity-selector",
    CustomQuantitySelector
  );
}
if (!window.customElements.get("custom-quantity-input")) {
  window.customElements.define("custom-quantity-input", CustomQuantityInput, {
    extends: "input",
  });
}
if (!window.customElements.get("custom-quantity-area-input")) {
  window.customElements.define(
    "custom-quantity-area-input",
    CustomQuantityAreaInput,
    {
      extends: "input",
    }
  );
}

export { CustomQuantitySelector };
